import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import type { MouseEventHandler, ReactNode } from 'react';

export const tValueBestBuy = {
  a: function a(chunks: ReactNode) {
    return <BodyLink href="/best-buy/store-locator">{chunks}</BodyLink>;
  },
};

export const tValueSizing = (
  onSizeLinkClick: MouseEventHandler<HTMLAnchorElement>,
) => ({
  a: function a(chunks: ReactNode) {
    return (
      <BodyLink
        className="text-orange-500"
        href="https://ouraring.com/sizing"
        target="_blank"
        onClick={onSizeLinkClick}
      >
        {chunks}
      </BodyLink>
    );
  },
});
